var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOuterBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2579 8.74023V27.2545H8.74365V8.74023H27.2579Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30957 8.30664H9.66921V9.1745H9.17743V9.66628H8.30957V8.30664ZM10.9035 8.30664H12.7549V9.1745H10.9035V8.30664ZM13.9892 8.30664H15.8406V9.1745H13.9892V8.30664ZM17.0749 8.30664H18.9264V9.1745H17.0749V8.30664ZM20.1606 8.30664H22.0121V9.1745H20.1606V8.30664ZM23.2464 8.30664H25.0978V9.1745H23.2464V8.30664ZM26.3321 8.30664H27.6917V9.66628H26.8239V9.1745H26.3321V8.30664ZM27.6917 10.9006V12.752H26.8239V10.9006H27.6917ZM8.30957 12.752V10.9006H9.17743V12.752H8.30957ZM27.6917 13.9863V15.8377H26.8239V13.9863H27.6917ZM8.30957 15.8377V13.9863H9.17743V15.8377H8.30957ZM8.30957 18.9234V17.072H9.17743V18.9234H8.30957ZM27.6917 17.072V18.9234H26.8239V17.072H27.6917ZM8.30957 22.0091V20.1577H9.17743V22.0091H8.30957ZM27.6917 20.1577V22.0091H26.8239V20.1577H27.6917ZM27.6917 23.2434V25.0949H26.8239V23.2434H27.6917ZM8.30957 25.0949V23.2434H9.17743V25.0949H8.30957ZM27.6917 26.3291V27.6888H26.3321V26.8209H26.8239V26.3291H27.6917ZM8.30957 26.3291H9.17743V26.8209H9.66921V27.6888H8.30957V26.3291ZM12.7549 27.6888H10.9035V26.8209H12.7549V27.6888ZM15.8406 27.6888H13.9892V26.8209H15.8406V27.6888ZM18.9264 27.6888H17.0749V26.8209H18.9264V27.6888ZM22.0121 27.6888H20.1606V26.8209H22.0121V27.6888ZM25.0978 27.6888H23.2464V26.8209H25.0978V27.6888Z",
    fill: "#326FAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2577 7.58301C27.8969 7.58301 28.4149 8.10102 28.4149 8.74015C28.4149 9.37928 27.8969 9.89729 27.2577 9.89729C26.6186 9.89729 26.1006 9.37928 26.1006 8.74015C26.1006 8.10102 26.6186 7.58301 27.2577 7.58301Z",
    fill: "#F3F6F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2581 8.01727C26.8586 8.01727 26.5348 8.34101 26.5348 8.74049C26.5348 9.13996 26.8586 9.4637 27.2581 9.4637C27.6575 9.4637 27.9813 9.13996 27.9813 8.74049C27.9813 8.34101 27.6575 8.01727 27.2581 8.01727ZM25.667 8.74049C25.667 7.8617 26.3793 7.14941 27.2581 7.14941C28.1368 7.14941 28.8491 7.8617 28.8491 8.74049C28.8491 9.61927 28.1368 10.3316 27.2581 10.3316C26.3793 10.3316 25.667 9.61927 25.667 8.74049Z",
    fill: "#326FAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74357 7.58301C9.3827 7.58301 9.90071 8.10102 9.90071 8.74015C9.90071 9.37928 9.3827 9.89729 8.74357 9.89729C8.10444 9.89729 7.58643 9.37928 7.58643 8.74015C7.58643 8.10102 8.10444 7.58301 8.74357 7.58301Z",
    fill: "#F3F6F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7439 8.01727C8.34443 8.01727 8.02069 8.34101 8.02069 8.74049C8.02069 9.13996 8.34443 9.4637 8.7439 9.4637C9.14338 9.4637 9.46712 9.13996 9.46712 8.74049C9.46712 8.34101 9.14338 8.01727 8.7439 8.01727ZM7.15283 8.74049C7.15283 7.86171 7.86512 7.14941 8.7439 7.14941C9.62268 7.14941 10.335 7.86171 10.335 8.74049C10.335 9.61927 9.62268 10.3316 8.7439 10.3316C7.86512 10.3316 7.15283 9.61927 7.15283 8.74049Z",
    fill: "#326FAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74357 26.0977C9.3827 26.0977 9.90071 26.6157 9.90071 27.2548C9.90071 27.8939 9.3827 28.4119 8.74357 28.4119C8.10444 28.4119 7.58643 27.8939 7.58643 27.2548C7.58643 26.6157 8.10444 26.0977 8.74357 26.0977Z",
    fill: "#F3F6F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7439 26.5319C8.34443 26.5319 8.02069 26.8557 8.02069 27.2551C8.02069 27.6546 8.34443 27.9783 8.7439 27.9783C9.14338 27.9783 9.46712 27.6546 9.46712 27.2551C9.46712 26.8557 9.14338 26.5319 8.7439 26.5319ZM7.15283 27.2551C7.15283 26.3764 7.86512 25.6641 8.7439 25.6641C9.62268 25.6641 10.335 26.3764 10.335 27.2551C10.335 28.1339 9.62268 28.8462 8.7439 28.8462C7.86512 28.8462 7.15283 28.1339 7.15283 27.2551Z",
    fill: "#326FAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2577 26.0977C27.8969 26.0977 28.4149 26.6157 28.4149 27.2548C28.4149 27.8939 27.8969 28.4119 27.2577 28.4119C26.6186 28.4119 26.1006 27.8939 26.1006 27.2548C26.1006 26.6157 26.6186 26.0977 27.2577 26.0977Z",
    fill: "#F3F6F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2581 26.5319C26.8586 26.5319 26.5348 26.8557 26.5348 27.2551C26.5348 27.6546 26.8586 27.9783 27.2581 27.9783C27.6575 27.9783 27.9813 27.6546 27.9813 27.2551C27.9813 26.8557 27.6575 26.5319 27.2581 26.5319ZM25.667 27.2551C25.667 26.3764 26.3793 25.6641 27.2581 25.6641C28.1368 25.6641 28.8491 26.3764 28.8491 27.2551C28.8491 28.1339 28.1368 28.8462 27.2581 28.8462C26.3793 28.8462 25.667 28.1339 25.667 27.2551Z",
    fill: "#326FAE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterBorder);
export default __webpack_public_path__ + "static/media/outer-border.963a67702838072459e98ba3c7186c8c.svg";
export { ForwardRef as ReactComponent };